export class  ButtonData {
  id: string;
  arrangementNumber: string;
  administrationCode: string;
  commercialProductTypeCode: string;
  label: string;
  tokenSort: string;
  url: string;
  data: any;

  constructor(id: string, arrangementNumber?: string, administrationCode?: string,
              commercialProductTypeCode?: string, label?: string, tokenSort?: string, url?: string, data?: any) {
    this.id = id;
    this.label = label;
    this.tokenSort = tokenSort;
    this.arrangementNumber = arrangementNumber;
    this.administrationCode = administrationCode;
    this.commercialProductTypeCode = commercialProductTypeCode;
    this.url = url;
    this.data = data;
  }
}
